export default class DesignUserUpdate {
  constructor(opts) {
    if (opts.success == "true") {
      $(opts.target).replaceWith(opts.html)
    } else {
      $(opts.target).slideUp();
    }
    $(opts.form).remove();
  }
}
